/* global angular */
import './style.less';
import { orderBy } from 'lodash';

import editExtensionModalTemplate from 'modals/editExtension/template.html';
import editExtensionModalCtrl from 'modals/editExtension';

export default function(
  $q,
  $state,
  $stateParams,
  $filter,
  $log,
  $uibModal,
  Swal,
  Upload,
  ApiClass,
  ProfileClass,
  RegulatorClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const reg_id = $stateParams.reg_id;
  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.licenseUpdateBtn = false;

  vm.opened = {
    expirationDate: false,
    extensionDate: false,
    issueDate: false,
    reportDate: false
  };

  function updateExtension(license) {
    const { extension, lic_yr } = license;
    const extension_date = new Date(license.extension_date).toISOString();

    vm.submitBtn = true;
    return ApiClass.usersIdTypeTypeIdPatch(
      { id: profile_uid, type: 'licenses', type_id: lic_yr },
      { extension_date, extension },
      {}
    )
      .then(() => {
        vm.submitBtn = false;
        Swal.toast('Updated Extension');
        activate();
      })
      .catch(error => {
        vm.submitBtn = false;
        $log.error(error);
        throw error;
      });
  }

  vm.editExtension = license => {
    $uibModal
      .open({
        size: 'md',
        backdrop: true,
        template: editExtensionModalTemplate,
        controller: editExtensionModalCtrl,
        controllerAs: 'editExtensionModalCtrl',
        resolve: {
          license: () => angular.copy(license)
        }
      })
      .result.then(data => {
        if (!data) return;

        return updateExtension(data);
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.removeExtension = license => {
    const lic_yr = license.lic_yr;

    vm.deleteBtn = true;
    ApiClass.usersIdTypeTypeIdPatch(
      { id: profile_uid, type: 'licenses', type_id: lic_yr },
      { extension_date: null, extension: null },
      {}
    )
      .then(() => {
        vm.deleteBtn = false;
        Swal.toast('Extension Deleted');
        license.extension_date = null;
        license.extension = null;
        activate();
      })
      .catch(error => {
        vm.deleteBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    vm.formData = {};
    vm.extensionFormData = {};

    const qArr = [
      RegulatorClass.loadRegulators(),
      ApiClass.usersIdGet(
        { id: profile_uid, manage: false },
        {},
        {
          queryParams: {
            'include:compliance': true,
            'include:flatcompliance': true
          }
        }
      )
    ];

    $q.all(qArr)
      .then(([{ obj: regulatorDict }, { data: { item: profile, flatcompliance } }]) => {
        const licenses = flatcompliance.filter(license => license.reg_id === reg_id);

        const years = orderBy(licenses, ['cycle_date'], ['desc']);
        const license = years[0];

        // check if attestation version of license exists
        vm.regulator = regulatorDict[license.reg_id][license.reg_date];

        vm.attestation = vm.regulator.join && vm.regulator.join.versions && vm.regulator.join.versions.attestation;
        vm.custom = vm.regulator.join && vm.regulator.join.versions && vm.regulator.join.versions.custom;
        const extension = vm.regulator.cycle_limiter.extension ? vm.regulator.cycle_limiter.extension : false;
        vm.extension = angular.copy(extension);
        vm.profile = profile;

        if (vm.extension) {
          vm.cycles = years.reduce((byCycle, cycle) => {
            const cycleYear = $filter('date')(cycle.cycle_date, 'yyyy');
            cycle.annual_year = `${$filter('date')(
              $filter('RangeDate')(cycle.cycle_date, cycle.cycle_limiter.cycle, 1),
              'MMM d, y'
            )} - ${$filter('date')(cycle.cycle_date, 'MMM d, y')}`;
            cycle.hasExtension = !!cycle.extension_date;
            cycle.extension = angular.copy(cycle.extension || extension);
            cycle.extension_date = cycle.hasExtension ? new Date(cycle.extension_date) : new Date(cycle.cycle_date);

            if (!byCycle[cycleYear] || Date(cycle.cycle_date) > Date(byCycle[cycleYear].cycle_date)) {
              byCycle[cycleYear] = cycle;
              byCycle[cycleYear].lic_yr = vm.regulator.rolling_cycle ? [...cycle.years][0] : [...cycle.years].pop();
            }

            return byCycle;
          }, {});

          vm.licenses = orderBy(Object.values(vm.cycles), ['annual_year'], ['desc']);
        }

        vm.resultsQueried = true;
        vm.formData = license;
        vm.formData.cycle_date = new Date(license.cycle_date);
        vm.formData.issue_date = new Date(license.issue_date);
        vm.formData.expiration_date = new Date(license.expiration_date);

        if (vm.attestation) vm.formData.attestation = reg_id === vm.regulator.join.versions.attestation;
        if (vm.custom) vm.formData.custom = reg_id === vm.regulator.join.versions.custom;
        if ('active' in vm.formData === false || license.active === undefined || license.active === null)
          vm.formData.active = true;

        let licenseType = $filter('Capitalize')(vm.regulator.license, 'license');

        if (reg_id.indexOf('firm') > -1) licenseType = 'Firm Requirement';
        if (reg_id.indexOf('at') > -1) licenseType += ' Attestation';

        vm.viewFormData = {
          license: licenseType,
          state: vm.regulator.basic_name
        };
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/licenses/license/extensions/index.js